import { controls, currencyToNumber, grouped } from "../../controls";

const loan_disbursement_register = {
  label: "Loan disbursement register",
  starting: true,
  url: "loan_register",
  pageLabel: "Loan Disbursement register",
  pageType: "history",
  filter: [
    ...controls.displayText({
      tab: "filter",
      label: "Branch"
    }),
    ...controls.oc({
      tab: "filter",
      length: 4,
      c: "Branch",
      defaultValue: "assigned_branch",
      placeHolder: "Branch Code",
      name: "branch_code",
      fastpath: "branches"
    }),
    ...controls.showData({
      tab: "filter",
      displaytype: "capital",
      data: "branch_display"
    }),

    ...controls.displayText({
      tab: "filter",
      label: "Society"
    }),
    ...controls.oc({
      tab: "filter",
      length: 4,
      c: "Society",
      placeHolder: "Society Code",
      name: "society_code",
      fastpath: "societies"
    }),
    ...controls.showData({
      tab: "filter",
      displaytype: "capital",
      data: "society_display"
    }),

    ...controls.magicDateLabel({
      label: "Date",
      target: "From_date"
    }),
    ...controls.magicDate({
      dateType: "ontype",
      default: "3 years ago",
      isRequired: true,
      name: "from_date",
      width: "col-sm-2"
    }),
    ...controls.magicDateLabel({
      label: "",
      width: "col-sm-2"
    }),

    ...controls.magicDateLabel({
      label: "Date",
      target: "to_date"
    }),
    ...controls.magicDate({
      dateType: "ontype",
      default: "n",
      isRequired: true,
      name: "to_date",
      width: "col-sm-2"
    }),
    ...controls.magicDateLabel({
      label: "",
      width: "col-sm-2"
    }),
  ],

  form: [],
  history: {
    perPage: 10,
    reportHeader: "Loan Disbursement register",
    pdfProps: {
      pageSize: "A4",
      pageOrientation: "landscape"
    },
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    displayColumns: [
      {
        Header: "Sr",
        type: "autoinc",
        accessor: "srno",
        align: "center",
        width: 30,
        width132: {
          size: 3
        }
      },
      {
        Header: "GL Code",
        accessor: "gl_code",
        width: 100
      },
      {
        Header: "GL Name",
        accessor: "gl_display",
        rwidth: "*",
      },
      {
        Header: "Member ID",
        accessor: "member_ID",
        width: 100
      },
      {
        Header: "Name",
        accessor: "member_name",
        width: 100
      },
      {
        Header: "Acccount No",
        accessor: "account_no"
      },
      {
        Header: "Sanction Date",
        accessor: "Sanction Date"
      },
      {
        Header: "Expiry Date",
        accessor: "expiry_Date"
      },
      {
        Header: "loan Disbursement bifercation",
        columns: [
          {
            Header: "cheque/bank",
            accessor: "cheque_Sanction"
          },
          {
            Header: "goods",
            accessor: "goods_Sanction"
          },
          {
            Header: "shares",
            accessor: "shares_Sanction"
          },
          {
            Header: "Deposit",
            accessor: "Deposit_Sanction"
          },
          {
            Header: "other",
            accessor: "other_Sanction"
          },
          {
            Header: "total",
            accessor: "total_Sanction"
          }
        ]
      },
      {
        Header: "Cheque No",
        accessor: "cheque_no"
      },
      {
        Header: "D Receipts",
        accessor: "d_receipt"
      },
      {
        Header: "Loan type",
        accessor: "loan_Date"
      },
      {
        Header: "int rate",
        accessor: "int_rate"
      },

      {
        Header: "Loan Reason",
        accessor: "loan_reason"
      },
      {
        Header: "Crop type",
        accessor: "crop_type"
      },
      {
        Header: "Sanction Amount",
        columns: [
          {
            Header: "ST",
            accessor: "st_Sanction"
          },
          {
            Header: "MT",
            accessor: "mt_Sanction"
          },
          {
            Header: "LT",
            accessor: "lt_Sanction"
          },
        ]
      },
      {
        Header: "Total Sanctioned loan ",
        accessor: "total_sanction"
      },
      {
        Header: "Saving Account no",
        accessor: "saving_account_no"
      },
      {
        Header: "Guarantor1",
        accessor: "Guarantor1"
      },
      {
        Header: "Guarantor2",
        accessor: "Guarantor2"
      },
      {
        Header: "Remark",
        accessor: "Remark"
      }
    ]
  }
}

export default loan_disbursement_register;